module.exports = __webpack_public_path__ + "img/DataEase-black.9ec6f903.png";